import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Icon } from '@scentregroup/ui';
import { isEmpty, isNull } from 'lodash';
import { summariseOccurrences } from '../../helpers/occurrences';
import { occurrencesType } from './../../types';
import ListEventTimes from './list-event-times';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Occurrences = _ref => {
  let {
    occurrences,
    className
  } = _ref;
  if (isEmpty(occurrences.times) || isEmpty(occurrences.times[0]) || isNull(occurrences.times[0].endAt)) {
    return null;
  }
  const isInline = occurrences.times.length === 1 || occurrences.summary;
  return /*#__PURE__*/_jsx("ul", {
    className: classNames(style.Occurrences, {
      [style.inline]: isInline
    }, className),
    "data-id": "occurrences_index_Occurrences_ul",
    children: isInline ? /*#__PURE__*/_jsxs("li", {
      className: classNames(style.occurrence, style.occurrenceHasIcon),
      "data-id": "occurrences_index_Occurrences_li",
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "hours",
        size: "small",
        className: classNames(style.occurrenceIcon),
        "data-id": "occurrences_index_Occurrences_li_Icon"
      }), summariseOccurrences(occurrences.times, occurrences.timeZone)]
    }) : /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("li", {
        "data-id": "occurrences_index_Occurrences_Fragment_li",
        children: /*#__PURE__*/_jsx(Icon, {
          type: "hours",
          size: "small",
          className: classNames(style.occurrenceIcon),
          "data-id": "occurrences_index_Occurrences_li_Icon"
        })
      }, "icon"), /*#__PURE__*/_jsx("li", {
        className: classNames(style.occurrenceTableWrap),
        "data-id": "occurrences_index_Occurrences_Fragment_li",
        children: /*#__PURE__*/_jsx(ListEventTimes, {
          occurrences: occurrences,
          "data-id": "occurrences_index_Occurrences_li_ListEventTimes"
        })
      }, "times")]
    })
  });
};
export default Occurrences;